import $ from "jquery";

$(document).ready(function(){
    $(".catalog-detail__table-size-link").click(function() {
        $(".catalog-detail__table-size-popup").toggleClass("catalog-detail__table-size-popup--active");
    });

    $(".catalog-detail__table-size-popup-close").click(function() {
        $(".catalog-detail__table-size-popup").removeClass("catalog-detail__table-size-popup--active");
    });

    $(".catalog-detail__add-btn").click(function() {
        $(".catalog-detail__add-btn").text('Добавлено!');
    });

    $(".catalog-detail__sku-item").click(function() {
        $(".catalog-detail__add-btn").text('В корзину');
    });
});

